module.exports = __webpack_public_path__ + "6f747d6482427837cb73c025c015a6d5.png";